import React from 'react';
import NIS2Assessment from './components/NIS2Assessment';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">
          NIS2 Compliance Assessment
        </h1>
        <NIS2Assessment />
      </div>
    </div>
  );
}

export default App;